// components/UserData/UserData.tsx
import React, { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../firebase';

interface UserDataProps {
  onSubmit: () => void;
  onClose: () => void;
}

const UserData: React.FC<UserDataProps> = ({ onSubmit, onClose }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');

  const isValidPhone = (phone: string) => {
    const phoneRegex = /^[6-9]\d{9}$/; // Starts with 6-9 and exactly 10 digits
    return phoneRegex.test(phone);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!isValidPhone(phone)) {
      alert('Please enter a valid 10-digit phone number starting with 6-9.');
      return;
    }

    try {
      const userRef = collection(db, 'users');
      await addDoc(userRef, {
        name,
        phone,
        timestamp: serverTimestamp(),
      });
      alert('🎉 Registered successfully!');
      onSubmit();
      onClose();
    } catch (error) {
      console.error('Error adding document:', error);
      alert('Failed to submit data. Please try again.');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Registration</h2>
          <button onClick={onClose} className="text-gray-500 text-2xl hover:text-gray-700">×</button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Name</label>
            <input
              type="text"
              className="w-full border p-2 rounded"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Phone Number</label>
            <input
              type="tel"
              className="w-full border p-2 rounded"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
              pattern="[6-9]{1}[0-9]{9}" // extra fallback for HTML validation
            />
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Submit & Continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default UserData;
